import React, { useState, useLayoutEffect, useEffect } from "react";
import {
  TextField,
  Link,
  Box,
  Typography,
  Container,
  Grid,
  Paper,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import apiClient from "../BaseUrl/apiClient";
import TokenService from "../service/TokenService";
import EncryptService from "../service/EncryptionService";
import logo from "../photo/logo.jpg";
import { useAuthentication } from "../customHook/useAuthentecation";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

let email = "";

const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
  },
  typography: {
    h5: { fontWeight: 700 },
  },
});

/* ================= FOOTERS (UNCHANGED) ================= */

function Copyright() {
  return (
    <Typography component="div" sx={{ fontSize: "10px" }} align="center">
      Copyright ©{" "}
      <Link href="https://www.mwsgkp.in">Machanical Workshop, Gorakhpur</Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

function Developer() {
  return (
    <Typography component="div" sx={{ fontSize: "10px" }} align="center">
      Software Developed by{" "}
      <Link href="https://www.sriyansh.com">Sriyansh Computers</Link>
    </Typography>
  );
}

/* ================= MAIN COMPONENT ================= */

export default function SignIn() {
  const [uname, setUname] = useState("");
  const [pastext, setPastext] = useState("");
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [loginData, setLoginData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [ipp, setIpp] = useState("");

  const navigate = useNavigate();
  const { setAuth } = useAuthentication();

  /* ================= IP FETCH ================= */
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIpp(data.ip))
      .catch(() => {});
  }, []);

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  /* ================= LOGIN LOGIC (UNCHANGED) ================= */

  const verifyOtp = (currentOtp = otp) => {
    try {
      if (error === currentOtp && currentOtp !== "") {
        TokenService.setTokenDetails(loginData);
        setAuth(loginData);

        sessionStorage.setItem("token1", EncryptService.encrypt(ipp));
        sessionStorage.setItem("token3", EncryptService.encrypt("erterte"));
        sessionStorage.setItem("token4", EncryptService.encrypt("dfgdfgdfg"));

        navigate("/dashboard");

        setOtp("");
        setUname("");
        setPastext("");
      }
    } finally {
      setButtonLoading(false);
    }
  };

  const getdata = async () => {
    try {
      setButtonLoading(true);
      const response = await apiClient.post("/getLoginData", {
        uname,
        pastext,
        ipp,
      });

      setLoginData(response.data[0]);
      email = response.data[0].emailid;
      await sendOtp();
    } catch {
      setError("Unexpected Error");
    } finally {
      setButtonLoading(false);
    }
  };

  const sendOtp = async () => {
    try {
      const res = await apiClient.post("/send-otp", { email });
      setError(res.data.message);
      setOtpSent(true);
    } catch {
      setError("Failed Generate Captcha");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    getdata();
  };

  useLayoutEffect(() => {
    document.body.style.background = "linear-gradient(135deg,#e3f2fd,#f5f5f5)";
  }, []);

  /* ================= UI ================= */

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: 360,
            p: 4,
            borderRadius: 3,
          }}
        >
          <Box textAlign="center" mb={2}>
            <img src={logo} alt="Logo" style={{ width: "70%" }} />
            <Typography variant="h6" fontWeight={700} mt={1}>
              Secure Login
            </Typography>
            <Typography fontSize={13} color="text.secondary">
              Authorized access only
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleSubmit}>
            {!otpSent && (
              <>
                <TextField
                  fullWidth
                  label="User Name"
                  value={uname}
                  onChange={(e) =>
                    setUname(e.target.value.toLowerCase())
                  }
                  margin="normal"
                  size="small"
                />

                <TextField
                  fullWidth
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  value={pastext}
                  onChange={(e) => setPastext(e.target.value)}
                  margin="normal"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setShowPassword(!showPassword)
                          }
                        >
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  disabled={buttonLoading}
                  sx={{
                    mt: 2,
                    py: 1,
                    fontWeight: 600,
                  }}
                >
                  Generate Captcha
                </Button>
              </>
            )}

            {/* 🔐 OTP / CAPTCHA SECTION (UNCHANGED) */}
            {otpSent && error && (
              <Box
                sx={{
                  mt: 2,
                  mb: 2,
                  p: 2,
                  textAlign: "center",
                  border: "2px dashed #1976d2",
                  borderRadius: "8px",
                  backgroundColor: "#f0f6ff",
                }}
              >
                <Typography variant="caption" mb={1}>
                  CAPTCHA CODE
                </Typography>

                <Typography
                  sx={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    letterSpacing: "6px",
                    color: "#d32f2f",
                    userSelect: "none",
                  }}
                >
                  {error}
                </Typography>
              </Box>
            )}

            {otpSent && (
              <TextField
                fullWidth
                label="Enter Captcha Code"
                value={otp}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  setOtp(val);
                  if (val.length === 6) verifyOtp(val);
                }}
                inputProps={{
                  maxLength: 6,
                  inputMode: "numeric",
                  style: {
                    textAlign: "center",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    letterSpacing: "0.6rem",
                  },
                }}
                sx={{ mt: 1 }}
              />
            )}
          </Box>

          <Box mt={3}>
            <Copyright />
            <Developer />
          </Box>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
